function _instanceof(left, right) {
	if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
	else return left instanceof right;
}
var dynamicImport = function(path) {
	console.info(`dynamicImport TODO`, path);
	return Promise.resolve(void 0);
};
var CHUNK_ERROR_PATTERNS = [
	"Failed to fetch dynamically imported module",
	"error loading dynamically imported module",
	"Importing a module script failed"
];
function isChunkLoadError(err) {
	var msg = _instanceof(err, Error) ? err.message : String(err);
	return CHUNK_ERROR_PATTERNS.some(function(p) {
		return msg.includes(p);
	});
}
function handleSkewError() {
	if (typeof window === "undefined") return false;
	var key = "__one_skew_reload";
	var last = sessionStorage.getItem(key);
	if (!last || Date.now() - Number(last) > 1e4) {
		sessionStorage.setItem(key, String(Date.now()));
		window.location.reload();
		return true;
	}
	return false;
}
var CHUNK_RETRY_ATTEMPTS = 3;
var CHUNK_RETRY_DELAY_MS = 500;
var realDelay = function(ms) {
	return new Promise(function(resolve) {
		return setTimeout(resolve, ms);
	});
};
async function loadWithRetry(loader) {
	var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
	var _options_attempts, _options_delayMs, _options_delay, _options_onChunkErrorExhausted;
	var attempts = (_options_attempts = options.attempts) !== null && _options_attempts !== void 0 ? _options_attempts : 3;
	var delayMs = (_options_delayMs = options.delayMs) !== null && _options_delayMs !== void 0 ? _options_delayMs : 500;
	var delay = (_options_delay = options.delay) !== null && _options_delay !== void 0 ? _options_delay : realDelay;
	var recover = (_options_onChunkErrorExhausted = options.onChunkErrorExhausted) !== null && _options_onChunkErrorExhausted !== void 0 ? _options_onChunkErrorExhausted : handleSkewError;
	var attempt = async function(retriesLeft) {
		try {
			return await loader();
		} catch (err) {
			if (retriesLeft > 0) {
				await delay(delayMs);
				return attempt(retriesLeft - 1);
			}
			if (isChunkLoadError(err) && recover()) return new Promise(function() {});
			throw err;
		}
	};
	return attempt(attempts);
}

export { CHUNK_RETRY_ATTEMPTS, CHUNK_RETRY_DELAY_MS, dynamicImport, handleSkewError, isChunkLoadError, loadWithRetry };